import slick from '@accessible360/accessible-slick';

export default function () {
	jQuery(function() {
		$('.quote__slider').slick({
			dots: true,
			arrows: false,
			adaptiveHeight: true,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		});
	});
}
